"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _InputComponent.default;
  }
});

var _InputComponent = _interopRequireDefault(require("./Input-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }